import {Box, Tooltip, Typography} from '@mui/material';
import {get_price_str} from 'common';

export default function PriceTag(props: {price: number; color?: string; tooltip?: string; sign_disabled?: boolean}) {
	const {price, color, tooltip, sign_disabled} = props;

	return (
		<Box>
			<Tooltip title={tooltip ?? ''} arrow placement="top">
				<Typography variant="caption" color={color}>
					{get_price_str(price, sign_disabled)}
				</Typography>
			</Tooltip>
		</Box>
	);
}
